<mat-dialog-actions class="justify-content-between">
  <h4 class="f-s-16 f-w-600 m-b-16">
    {{ 'ABDM.REQUEST_DIALOG_TITLE' | translate }}
  </h4>
  <button mat-icon-button class="d-flex justify-content-center" mat-dialog-close>
    <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
  </button>
</mat-dialog-actions>
<mat-dialog-content [formGroup]="form">
  <div class="m-b-16 f-s-13">
    <div *ngIf="data.abhaAddress">
      <span class="text-muted">{{ 'ABDM.PATIENT_ABHA_ADDRESS' | translate }}:</span>
      <strong> {{ data.abhaAddress }}</strong>
    </div>
    <div *ngIf="data.abhaNumber">
      <span class="text-muted">{{ 'ABDM.PATIENT_ABHA_NUMBER' | translate }}:</span>
      <strong> {{ data.abhaNumber }}</strong>
    </div>
  </div>
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>{{ 'ABDM.PURPOSE' | translate }}</mat-label>
    <input matInput formControlName="purposeText">
  </mat-form-field>
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>{{ 'ABDM.HEALTH_INFORMATION_TYPES' | translate }}</mat-label>
    <mat-select formControlName="hiTypes" multiple>
      <mat-option *ngFor="let type of hiTypes" [value]="type">{{ type }}</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>{{ 'ABDM.RECORDS_FROM' | translate }}</mat-label>
    <input matInput [matDatepicker]="fromPicker" formControlName="permissionFrom" [max]="maxDate">
    <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
    <mat-datepicker #fromPicker></mat-datepicker>
  </mat-form-field>
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>{{ 'ABDM.RECORDS_TO' | translate }}</mat-label>
    <input matInput [matDatepicker]="toPicker" formControlName="permissionTo" [max]="maxDate">
    <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
    <mat-datepicker #toPicker></mat-datepicker>
  </mat-form-field>
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>{{ 'ABDM.ERASE_RECEIVED_DATA_ON' | translate }}</mat-label>
    <input matInput [matDatepicker]="erasePicker" formControlName="dataEraseAt" [min]="today">
    <mat-datepicker-toggle matSuffix [for]="erasePicker" ></mat-datepicker-toggle>
    <mat-datepicker #erasePicker></mat-datepicker>
  </mat-form-field>
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>{{ 'ABDM.ERASE_RECEIVED_DATA_TIME' | translate }}</mat-label>
    <input matInput type="time" formControlName="dataEraseTime">
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ 'BUTTON.BTN_CANCEL' | translate }}</button>
  <button mat-flat-button color="primary" [disabled]="form.invalid || submitting" (click)="submit()">
    {{ 'ABDM.REQUEST_CONSENT' | translate }}
  </button>
</mat-dialog-actions>
